// eslint-disable-next-line no-unused-vars
import React from 'react';

const scrollTo = ({selector, transition = 'smooth', timeout = 500}) => {
  setTimeout(() => {
    // IE fallback.
    try {
      document.querySelector(selector).scrollIntoView({behavior: transition});
    } catch (error) {
      console.warn('The browser doesn\'t support Smooth scroll');
    }
  }, timeout);
};

export default scrollTo;
